import type { FC } from 'react';
import * as LucideIcons from 'lucide-react';
import { cn } from '@/utils/cn';

type IconName = keyof typeof LucideIcons;

interface IconProps {
  name: string;
  size?: number;
  className?: string;
}

/**
 * Dynamically renders any Lucide icon by string name.
 * Falls back to a question-mark circle if the name is not found.
 */
export const Icon = ({ name, size = 16, className }: IconProps) => {
  const Component = (LucideIcons[name as IconName] ?? LucideIcons['HelpCircle']) as FC<{
    size?: number;
    className?: string;
  }>;
  return <Component size={size} className={cn(className)} />;
};
